var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenhouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_14723)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 0H3.6C1.61178 0 0 1.61177 0 3.6V20.4C0 22.3882 1.61178 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61177 22.3882 0 20.4 0Z",
    fill: "#008561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.988 8.75281C14.988 9.52567 14.6465 10.2092 14.0861 10.7441C13.463 11.3382 12.5604 11.4867 12.5604 11.9921C12.5604 12.6756 13.7122 12.4673 14.8172 13.5221C15.5491 14.2207 16 15.142 16 16.2113C16 18.3209 14.2258 20 12 20C9.77418 20 8 18.3228 8 16.2133C8 15.1433 8.45164 14.222 9.18279 13.524C10.2878 12.4686 11.4396 12.6769 11.4396 11.9934C11.4396 11.488 10.5377 11.3395 9.91463 10.7454C9.35422 10.2105 9.01205 9.52699 9.01205 8.72455C9.01205 7.18015 10.3346 5.93149 11.9532 5.93149C12.2651 5.93149 12.5453 5.97618 12.7787 5.97618C13.1986 5.97618 13.4169 5.79808 13.4169 5.51549C13.4169 5.35184 13.3384 5.14417 13.3384 4.92138C13.3384 4.416 13.79 4 14.3346 4C14.8799 4 15.3157 4.43112 15.3157 4.95096C15.3157 5.50037 14.864 5.75273 14.5219 5.87234C14.2417 5.96106 14.0234 6.08001 14.0234 6.34749C14.0234 6.8509 14.988 7.34182 14.988 8.75281ZM14.6781 16.2133C14.6781 14.7425 13.5422 13.5536 12.0007 13.5536C10.4599 13.5536 9.32392 14.7425 9.32392 16.2133C9.32392 17.6689 10.4599 18.8729 12.0007 18.8729C13.5415 18.8729 14.6781 17.6676 14.6781 16.2133ZM13.759 8.72324C13.759 7.7874 12.9652 7.01454 12 7.01454C11.0355 7.01454 10.2417 7.7874 10.2417 8.72324C10.2417 9.65908 11.0355 10.4319 12 10.4319C12.9652 10.4319 13.759 9.65908 13.759 8.72324Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_14723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenhouse);
export default __webpack_public_path__ + "static/media/greenhouse.f0a02dbfd3be918b5152ca76d3d4bca6.svg";
export { ForwardRef as ReactComponent };